//WE.Flow.Html.Contracts.Manifests.Components.ComponentManifest
import { ToolbarItemManifest } from "./ToolbarItemManifest";
import { ConfigItemManifest } from "./ConfigItemManifest";
import { GroupMenuManifest } from "./GroupMenuManifest";
import { CustomGroupMenuManifest } from "./CustomGroupMenuManifest";

export class ComponentManifest {
    id: string = "";
    name: string = "";
    toolbarItem: ToolbarItemManifest = null;
    useDefaultViewModel: boolean = false;
    viewUrl: string = "";
    namespace: string = "";
    viewModelId: string = "";
    isVisibleOnHomeScreen: boolean = false;
    hasNoWorkingContext: boolean = false;
    reuseInstance: boolean = false;
    useFormValidation: boolean = false;
    useValidationV3: boolean = false;
    minimizedHeight: string = "";
    minimizedWidth: string = "";
    cssUrls: string[] = null;
    moduleRoles: string[] = null;
    canMaximize: boolean = false;
    useForSingleComponetMax: boolean = false;
    configItem: ConfigItemManifest = null;
    maximizeToEdge: boolean = false;
    useDynamicBottomNavigationTitle: boolean = false;
    groupMenuItem: GroupMenuManifest = null;
    customGroupMenuItem: CustomGroupMenuManifest = null;
    defaultParameters: any = null;
    tags: string[] = null;
    isEmbedded: boolean = false;
    bundle: string = "";
    order: number = 0;
    defaultHidden: boolean = false;
}
